import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./SettingsServiceSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useMemo, useState } from "react";
import SettingsServiceFormStepOne from "./SettingsServiceSteps/SettingsServiceFormStepOne";
import SettingsServiceFormStepTwo from "./SettingsServiceSteps/SettingsServiceFormStepTwo";
import SettingsServiceFormStepThree from "./SettingsServiceSteps/SettingsServiceFormStepThree";

const SettingsServiceForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update } = props;

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update && props.initialValues) {
      setInitialValues({ ...props.initialValues });
    }
  }, [update, props.initialValues]);

  const safeInitialValues = useMemo(() => {
    return initialValues || {};
  }, [initialValues]);

  return (
    <Form
      initialValues={safeInitialValues}
      onSubmit={(val) => onSubmit(val, { ...props, initialValues })}
      validate={(val) => onValidate(val, props)}
    >
      {({ handleSubmit }) => (
        <form id={props.formName} onSubmit={handleSubmit}>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={step}
            onChangeIndex={() => {

            }}
          >
            <SettingsServiceFormStepOne initialValues={safeInitialValues} />
            <SettingsServiceFormStepTwo initialValues={safeInitialValues} />
            <SettingsServiceFormStepThree initialValues={safeInitialValues} />
          </SwipeableViews>
        </form>
      )}
    </Form>
  );
};

export default SettingsServiceForm;